export default __webpack_public_path__ + "media/images/react_icons/location_outline_filters_black-0fe3404c83e8b723c97fd439b9662f16.svg";